"use client";

import { DialogTitle } from "@headlessui/react";
import { Check } from "@phosphor-icons/react";
import { useSearchParams } from "next/navigation";
import type React from "react";
import { useEffect, useState } from "react";
import Popup from "./Popup";

const ThankYouPopup: React.FC = () => {
  const [thankYouPopupOpen, setThankYouPopupOpen] = useState<boolean>(false);
  const searchParams = useSearchParams();

  useEffect(() => {
    setThankYouPopupOpen(!!searchParams.get("success"));
  }, [searchParams]);

  const refreshPage = () => {
    window.location.href = "/";
  };

  return (
    <Popup onClose={refreshPage} isOpen={thankYouPopupOpen}>
      <div>
        <input type="hidden" className="hidden" name="OPT_IN" value="1" />
        <input type="hidden" className="hidden" name="email_address_check" value="true" />
        <input type="hidden" className="hidden" name="locale" value="en" />
        <div className="mt-3 text-center sm:mt-5">
          <DialogTitle as="h3" className="text-5xl flex justify-center font-semibold leading-6 text-white">
            <Check className="h-14 w-20 text-green-500" />
          </DialogTitle>
          <div className="mt-3">
            <p className="text-2xl text-white">Great you&apos;re in!</p>
          </div>
          <div className="mt-3">
            <p className="text-base text-gray-500">We&apos;ll let you know when we&apos;re ready.</p>
          </div>
        </div>
      </div>
      <div className="mt-5 sm:mt-6">
        <button
          type="button"
          onClick={refreshPage}
          className="inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-black shadow-sm"
        >
          Close
        </button>
      </div>
    </Popup>
  );
};

export default ThankYouPopup;
